module.exports = "<a href=\"\" ng-click=\"$ctrl.logout()\" class=\"logout-link\">Log Out</a>";